export const API_BASE = "/api";

export const WORDLIST_URL = "/wordlist-table.txt";

export const KEYBOARD_ROWS = [
  ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
  ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
  ["Z", "X", "C", "V", "B", "N", "M"]
];

export const FLIP_DURATION = 350; // ms each tile flip (snappier, Wordle-ish)
export const FLIP_STAGGER = 150;  // ms between tiles (Wordle-style)

export const LOGO_SRC = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAACAAAAAIeCAYAAAAvC++VAAAQAElEQVR4Aez9B5wcZ3nnef4j0lZleYuqgvfeAwRoQTYdaEDTbN9qJzuj0Yy00mqk3bnZnZvZ+9zO7tzc3Y4fjaYldbfaqNWG3U2y6R1IggaEBwjvgfLepYmNKNCAJIDKQlVmxhv5SyJYWZkRbzzP942IeuONNyPtvQffdpgwYBtgG2AbYBtgG2AbYBtgG2AbYBtgG2AbYBsI9DbAuT/9H2wDbANsA2wDbANsA2wDbANsA2wDbANsA2wDwd8GHFs8EEAAAQQQQAABBBBAAAEEEEAg4AKkhwACCCCAAAIIIIAAAggggAACwReQGABQDLVMjggggAACCCCAAAIIIIAAAsUtQPYIIIAAAggggAACCCCAAAIIBB8ATdDBgC4CPxDAAEEEEAAAQQQQAABBBBAIMgC...";
